import React, { useContext, useState } from 'react'
import BigModal from '../../../../../../components/Modals/BigModal'
import { Box, Button, Checkbox, Grid, Stack, Typography } from '@mui/material'
import SmallModal from '../../../../../../components/Modals/SmallModal'

const SedationChecklist = ({ open, onClose, submitModule }) => {
  const [checklistOptions, setCheckListOptions] = useState({
    'Patient Details and Allergy Status': false,
    'Sufficient Oxygen': false,
    'Pre-Oxygenation': false,
    'BVM & Emergency Airway Equipment Available': false,
    'Patient Optimally Positioned': false,
    'Monitoring - SPO2, NIBP, ECG, ETCO2, RR': false,
    'Agents Selected and Prepared': false,
    'Team Briefed': false,
  })

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      style={{ width: '400px', maxWidth: '80vw' }}
    >
      <Stack overflow="auto">
        <Typography variant="title2">Sedation Checklist</Typography>
        {[
          Object.keys(checklistOptions).map((option, index) => (
            <Stack
              direction="row"
              marginY={0.5}
              alignItems="center"
              onClick={(e) =>
                setCheckListOptions((prev) => ({
                  ...prev,
                  [option]: !prev[option],
                }))
              }
              sx={{ cursor: 'pointer' }}
              key={index}
            >
              <Checkbox checked={!!checklistOptions[option]} />
              <Typography>{option}</Typography>
            </Stack>
          )),
        ]}
        <Grid xs={12} container spacing={1}>
          <Grid item xs={12} lg={4}>
            <Button
              color="error"
              onClick={() => onClose()}
              variant="contained"
              fullWidth
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Button
              color="success"
              onClick={() => {
                submitModule('Sedation Checklist', {
                  ...checklistOptions,
                  isChecklist: true,
                })
                onClose()
              }}
              variant="contained"
              fullWidth
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </SmallModal>
  )
}

export default SedationChecklist
